import { render } from "./document-views.vue?vue&type=template&id=67264080"
import script from "./document-views.vue?vue&type=script&lang=js"
export * from "./document-views.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__